export default "__VITE_ASSET__B4My4njN__"